import { CoutrProceedingGridComponent } from './court-proceedings/court-proceeding/coutr-proceeding-grid/coutr-proceeding-grid.component';
import { CoutrProceedingMenuComponent } from './court-proceedings/coutr-proceeding-menu/coutr-proceeding-menu.component';
import { FinalReportMenuComponent } from './final-reports/final-report-menu/final-report-menu/final-report-menu.component';
import { FinalReportFormComponent } from './final-reports/final-report/final-report-form/final-report-form.component';
import { CaseDairyMenuComponent } from './case-dairys/case-dairy-menu/case-dairy-menu/case-dairy-menu.component';
import { CaseDairyFormComponent } from './case-dairys/case-dairy/case-dairy-form/case-dairy-form.component';
import { CaseDairyGridComponent } from './case-dairys/case-dairy/case-dairy-grid/case-dairy-grid.component';
import { EnquiryReportFormComponent } from './enquiry-reports/enquiry-report/enquiry-report-form/enquiry-report-form.component';
import { EnquiryReportGridComponent } from './enquiry-reports/enquiry-report/enquiry-report-grid/enquiry-report-grid.component';
import { EnquiryReportMenuComponent } from './enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component';

import { ComplaintsTypeGridComponent } from './masters/Complaints-types/complaints-type-grid/complaints-type-grid.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule} from '@angular/router';

//Material Design Css import
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule} from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule} from '@angular/material/radio';
import { MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SettingComponent } from './ultilities/setting/setting.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import {NgxPaginationModule} from 'ngx-pagination';
import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';

import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { DistrictGridComponent } from './masters/district/district-grid/district-grid.component';

import { DistrictFormComponent } from './masters/district/district-form/district-form.component';
import { DistrictComponent } from './masters/district/district.component';
import { MastersComponent } from './masters/masters.component';
import { MasterMenuComponent } from './masters/master-menu/master-menu.component';
import { VehicleGridComponent } from './ultilities/vehicle/vehicle-grid/vehicle-grid.component';
import { VehicleFormComponent } from './ultilities/vehicle/vehicle-form/vehicle-form.component';
import { CorrespondanceTrackingComponent } from './correspondance-tracking/correspondance-tracking.component';
import { CtGridComponent } from './correspondance-tracking/ct-grid/ct-grid.component';
import { CtFormComponent } from './correspondance-tracking/ct-form/ct-form.component';
import { CtMenuComponent } from './correspondance-tracking/ct-menu/ct-menu.component';
import { TalukComponent } from './masters/taluk/taluk.component';
import { TalukGridComponent } from './masters/taluk/taluk-grid/taluk-grid.component';
import { TalukFormComponent } from './masters/taluk/taluk-form/taluk-form.component';
import { OfficeGridComponent } from './masters/office/office-grid/office-grid.component';
import { OfficeFormComponent } from './masters/office/office-form/office-form.component';
import { FooterComponent } from './common/footer/footer.component';
import { ComplaintsTypeFormComponent } from './masters/Complaints-types/complaints-type-form/complaints-type-form.component';
import { EnactmentFormComponent } from './masters/Enactment/enactment-form/enactment-form.component';
import { EnactmentGridComponent } from './masters/Enactment/enactment-grid/enactment-grid.component';
import { MaintenanceFormComponent } from './masters/Maintenance-office/maintenance-form/maintenance-form.component';
import { ComplaintsComponent } from './Complaints/complaints.component';
import { ComplaintsFormComponent } from './Complaints/complaints-form/complaints-form.component';
import { JurisdictionGridComponent } from './masters/Jurisdiction/jurisdiction-grid/jurisdiction-grid.component';
import { JurisdictionFormComponent } from './masters/Jurisdiction/jurisdiction-form/jurisdiction-form.component';
import { MaintenanceGridComponent } from './masters/Maintenance-office/maintenance-grid/maintenance-grid.component';
import { ComplaintGridComponent } from './Complaints/complaint-grid/complaint-grid.component';
import { InvestigationDocsComponent } from './investigation-docs/investigation-docs.component';

import { InvDocGridComponent } from './investigation-docs/inv-doc-grid/inv-doc-grid.component';
import { FirFormComponent } from './FIR/fir-form/fir-form.component';
import { FirGridComponent } from './FIR/fir-grid/fir-grid.component';
import { FirComponent } from './FIR/fir.component';
import {DepartmentFormComponent} from './masters/department/department-form/department-form.component';
import {DepartmentGridComponent} from './masters/department/department-grid/department-grid.component';
import { FirProceGridComponent } from './investigation-docs/fir-proceeding-list/fir-proce-grid/fir-proce-grid.component';
import { InvestigationGridComponent } from './investigationdocs-for-investigation/investigation-grid/investigation-grid.component';
import { InvestigationFormComponent } from './investigationdocs-for-investigation/investigation-form/investigation-form.component';
import { DeptDocumentFormComponent } from './masters/dept-document/dept-document-form/dept-document-form.component';
import { DeptDocumentGridComponent } from './masters/dept-document/dept-document-grid/dept-document-grid.component';
import { FinalReportGridComponent } from './final-reports/final-report/final-report-grid/final-report-grid.component';
import { CoutrProceedingFormComponent } from './court-proceedings/court-proceeding/coutr-proceeding-form/coutr-proceeding-form.component';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SettingComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    HomepageComponent,
    ChangePasswordComponent,
    DistrictGridComponent,    
    DistrictFormComponent,
    DistrictComponent,
    MastersComponent,
    MasterMenuComponent,
    VehicleGridComponent,
    VehicleFormComponent,
    CorrespondanceTrackingComponent,
    CtGridComponent,
    CtFormComponent,
    CtMenuComponent,
    TalukComponent,
    TalukGridComponent,
    TalukFormComponent,
    OfficeGridComponent,
    OfficeFormComponent,
    FooterComponent,
    ComplaintsTypeGridComponent,
    ComplaintsTypeFormComponent,
    EnactmentGridComponent,
    EnactmentFormComponent,
    MaintenanceGridComponent,
    MaintenanceFormComponent,
    ComplaintsComponent,
    ComplaintsFormComponent,
    JurisdictionGridComponent,
    JurisdictionFormComponent,
    ComplaintGridComponent,
    InvestigationDocsComponent,    
    InvDocGridComponent,
    FirComponent,
    FirGridComponent,
    FirFormComponent,
    DepartmentFormComponent,
    DepartmentGridComponent,
    FirProceGridComponent,  
    ForgotPasswordComponent, 
    InvestigationGridComponent, 
    InvestigationFormComponent, 
    DeptDocumentFormComponent, DeptDocumentGridComponent, 
    EnquiryReportFormComponent,EnquiryReportGridComponent, EnquiryReportMenuComponent,
    CaseDairyFormComponent,CaseDairyGridComponent,CaseDairyMenuComponent,
    FinalReportFormComponent,FinalReportGridComponent,FinalReportMenuComponent, 
    CoutrProceedingFormComponent,CoutrProceedingGridComponent,CoutrProceedingMenuComponent,
    
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule,MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [UserService, ErrorHandler,AuthGuard,{provide: LocationStrategy, useClass: HashLocationStrategy},
  // {
  //   provide: HTTP_INTERCEPTORS,
  //   useClass:AuthInterceptor,
  //   multi:true
  // }
],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts